module.exports = __webpack_public_path__ + "static/media/19ESCAP5.6b6a63c2.jpg";